import { Injectable } from '@angular/core';
import { Analytics, getAnalytics, isSupported, logEvent, setCurrentScreen, setUserId, setUserProperties } from '@angular/fire/analytics';
import { getApp } from '@angular/fire/app';
import { UserAnalyticsInterface } from '../../../../../managers/user-manager/src/lib/interfaces/user.interface';

@Injectable({ providedIn: 'root' })
export class FirebaseAnalyticsService {
  private isSupported = false;
  private analytics: Analytics;

  constructor() {
    isSupported().then((supported) => {
      this.isSupported = supported;
      if (supported) {
        this.analytics = getAnalytics(getApp());
      }
    });
  }

  public async track(event: string, properties: { [key: string]: any } = {}): Promise<void> {
    try {
      if (!this.isSupported) {
        return;
      }

      logEvent(this.analytics, event, properties);
    } catch (error) {
      console.error(`📃 ~ FirebaseAnalyticsService service ~ Track Error ~ ${event}`, properties);
    }
    return;
  }

  public async page(name: string, properties: { url: string }): Promise<void> {
    try {
      if (!this.isSupported) {
        return;
      }
      setCurrentScreen(this.analytics, properties.url);
    } catch (error) {
      console.error(`📃 ~ FirebaseAnalyticsService service ~ Page Error ~ ${event}`, properties);
    }
    return;
  }

  public async identify(userId: string, userData: UserAnalyticsInterface, params: any = {}): Promise<void> {
    if (!this.isSupported) {
      return;
    }
    if (!userId || !userData) {
      throw new Error('userId and userData are required');
    }
    try {
      const eventToSend = { userData, params };
      logEvent(this.analytics, 'identify', eventToSend);
      setUserId(this.analytics, userId);
      setUserProperties(this.analytics, eventToSend);
    } catch (error) {
      console.error(`📃 ~ FirebaseAnalyticsService service ~ Identify Error ~ ${event}`, userId, userData);
    }
    return;
  }
}
